import { render, staticRenderFns } from "./TableLoan.vue?vue&type=template&id=78c6d72d"
import script from "./TableLoan.vue?vue&type=script&lang=js"
export * from "./TableLoan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports